import { SvgIcon } from '@material-ui/core';
import { ReactComponent as points } from './points.svg';

export default function PointIcon(props) {
  return <SvgIcon {...props} component={points} viewBox="0 0 502.06 498.25" />;
}
